<template>
  <div class="salon-detail">
    <van-form>
      <van-field
        v-model="form.username"
        name="沙龙主题"
        label="沙龙主题:"
        placeholder="请输入沙龙主题"
      >
        <template #input>
          {{ form.booking_title }}
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        name="picker"
        label="渠道:"
        placeholder="点击选择渠道"
      >
        <template #input>
          {{ form.channel_name }}
        </template>
      </van-field>

      <van-field
        v-model="form.username"
        name="渠道备注"
        label="渠道备注:"
        placeholder="请输入渠道备注"
      >
        <template #input>
          {{ form.channel_remark }}
        </template>
      </van-field>
      <van-field
        v-model="form.username"
        name="联系人"
        label="联系人:"
        placeholder="请输入联系人"
      >
        <template #input>
          {{ form.contact_user }}
        </template>
      </van-field>
      <van-field
        v-model="form.username"
        name="联系人电话"
        label="联系人电话:"
        placeholder="请输入联系人电话"
      >
        <template #input>
          {{ form.contact_phone }}

        </template>
      </van-field>
      <van-field
        name="switch"
        label="是否茶歇:"
      >
        <template #input>
          {{ form.tea_break_flag ? '是' : '否' }}

          <span class="salon-chaxie">
            {{ form.tea_break_desc }}
          </span>
        </template>
      </van-field>
      <van-field
        v-show="form.tea_break_flag"
        name="radio"
        label="茶歇备注:"
      >
        <template #input>
          {{ form.tea_break_remark }}
        </template>
      </van-field>
      <van-field
        name="radio"
        label="讲座专家:"
      >
        <template #input>
          {{ form.expert_type }}专家
        </template>
      </van-field>
      <van-field
        v-show="form.expert_type === '本院'"
        readonly
        clickable
        name="picker"
        :value="form.value"
        label="本院专家:"
        placeholder="点击选择本院专家"
        @click="showPicker = true"
      >
        <template #input>
          {{ form.expert_name }}
        </template>
      </van-field>

      <van-field
        v-show="form.expert_type === '外院'"
        v-model="form.username"
        name="外院专家"
        label="外院专家:"
        placeholder="请输入外院专家"
      >
        <template #input>
          {{ form.expert_name }}

        </template>
      </van-field>
      <van-field
        v-model="form.username"
        name="体验项目"
        label="体验项目:"
        placeholder="请输入体验项目"
      >
        <template #input>
          {{ form.medical_item }}
        </template>
      </van-field>
      <van-field
        readonly
        clickable
        name="picker"
        :value="form.value"
        label="摆台样式:"
        placeholder="点击选择摆台样式"
      >
        <template #input>
          {{ form.table_type_name }}
        </template>
      </van-field>
      <van-field
        v-model="form.remark"
        name="备注"
        label="备注:"
        placeholder="请输入备注"
      >
        <template #input>
          {{ form.remark }}
        </template>
      </van-field>
      <van-field
        v-model="form.expect_people_num"
        name="预计人数"
        label="预计人数:"
        placeholder="请输入预计人数"
      >
        <template #input>
          {{ form.expect_people_num }}
        </template>
      </van-field>
      <van-field
        v-model="form.expect_receivable"
        name="预计应收费用"
        label="预计应收费用:"
        placeholder="请输入预计应收费用"
      >
        <template #input>
          {{ form.expect_receivable }}
        </template>
      </van-field>
      <van-field
        v-model="form.pay_type"
        name="结算方式"
        label="结算方式:"
        placeholder="请输入结算方式"
      >
        <template #input>
          {{ form.pay_type }}
        </template>
      </van-field>

    </van-form>
  </div>
</template>
  
  <script>
import meetingService from "@/apis/meeting/index.js";

export default {
  data() {
    return {
      form: {},
    };
  },
  created() {
    this.getBookingDetail();
  },
  methods: {
    getBookingDetail() {
      const params = {
        booking_id: this.$route.query.booking_id,
      };
      meetingService.getBookingDetail(params).then((res) => {
        this.form = res;
        console.log(res);
      });
    },
    onConfirm() {},
  },
};
</script>
  
  <style lang="scss" scoped>
.salon-detail {
}
</style>